import React, { useState } from 'react';
import { FiBookOpen, FiChevronLeft, FiShield, FiCreditCard, FiUsers, FiStar, FiLock, FiAlertCircle } from 'react-icons/fi';

const SECTIONS = [
  {
    id: 'intro',
    icon: FiBookOpen,
    title: 'التعريفات ونطاق التطبيق',
    tldr: 'هذه الشروط تنظم علاقتك مع تطبيق خدمة كعميل أو كمقدم خدمة.',
    body: [
      'تُشكّل هذه الوثيقة اتفاقية ملزمة بينك وبين تطبيق "خدمة"، وتنطبق على كل استخدام للتطبيق سواء كنت "عميلاً" يطلب خدمة أو "مقدم خدمة" يقدّمها.',
      'يُقصد بـ "المنصة" التطبيق بجميع صفحاته وخدماته، بما في ذلك المحفظة الرقمية، بطاقة العضوية، المتجر الرقمي، والمحادثات بين المستخدمين.',
      'استخدامك للتطبيق يعني موافقتك الكاملة على هذه الشروط وعلى أي تحديثات لاحقة لها.'
    ]
  },
  {
    id: 'account',
    icon: FiUsers,
    title: 'إنشاء الحساب والتسجيل',
    tldr: 'معلوماتك يجب أن تكون صحيحة، وأنت مسؤول عن حسابك وكلمة المرور.',
    body: [
      'يجب تقديم بيانات دقيقة وحديثة عند التسجيل، ويحق للتطبيق طلب التحقق من الهوية في أي وقت لضمان سلامة المنصة.',
      'أنت المسؤول الوحيد عن الحفاظ على سرية بيانات الدخول الخاصة بحسابك، وعن أي نشاط يتم من خلاله.',
      'لا يجوز إنشاء أكثر من حساب واحد لنفس الشخص لنفس الغرض (عميل أو مقدم خدمة) دون إذن صريح من إدارة التطبيق.',
      'يجب أن يكون عمر المستخدم 18 عامًا فأكثر، أو أن يستخدم التطبيق بإشراف ولي أمر عند الاقتضاء.'
    ]
  },
  {
    id: 'client-duties',
    icon: FiUsers,
    title: 'التزامات العميل',
    tldr: 'اطلب الخدمة بوضوح، وادفع في وقتها، وتعامل باحترام.',
    body: [
      'يتحمّل العميل مسؤولية وصف الخدمة المطلوبة بدقة عند التواصل مع مقدم الخدمة، لتفادي أي سوء فهم.',
      'الالتزام بسداد المستحقات المتفق عليها في الوقت المحدد عبر وسائل الدفع المعتمدة في التطبيق.',
      'يُمنع الطلب الوهمي للخدمات أو إساءة استخدام ميزة الطلبات لأي غرض غير جاد.'
    ]
  },
  {
    id: 'provider-duties',
    icon: FiShield,
    title: 'التزامات مقدم الخدمة',
    tldr: 'قدّم خدمتك بمهنية، والتزم بما هو معروض في ملفك الشخصي.',
    body: [
      'يجب على مقدم الخدمة تقديم خدماته بمهنية واحترافية، والالتزام بالمواعيد والأسعار المعلنة في ملفه العام.',
      'يتحمّل مقدم الخدمة وحده مسؤولية جودة الخدمة المقدَّمة ومطابقتها للأنظمة والقوانين المحلية المعمول بها.',
      'يُمنع نشر معلومات مضلّلة عن الخبرات أو المؤهلات في الملف الشخصي أو بطاقة العضوية.'
    ]
  },
  {
    id: 'payments',
    icon: FiCreditCard,
    title: 'المدفوعات، المحفظة، والعمولات',
    tldr: 'الدفع يتم عبر المنصة، وتُخصم عمولة 10% من كل معاملة.',
    body: [
      'تتم جميع المدفوعات عبر قنوات الدفع الآمنة المتاحة داخل التطبيق (البطاقة البنكية أو المحفظة الرقمية).',
      'تُطبَّق عمولة خدمة نسبتها 10% على كل معاملة مكتملة، وتُخصم تلقائيًا قبل تحويل المستحقات لمقدم الخدمة.',
      'أي طلب سحب من المحفظة يخضع للمراجعة والتحقق قبل التنفيذ، وقد يستغرق التحويل بضعة أيام عمل.',
      'يجب الاحتفاظ بإيصال الدفع (في حال الدفع اليدوي) حتى تأكيد المعاملة من قِبل الطرفين.'
    ]
  },
  {
    id: 'cancellation',
    icon: FiAlertCircle,
    title: 'الإلغاء والاسترداد',
    tldr: 'يمكن الإلغاء قبل بدء تنفيذ الخدمة وفق سياسة الاسترداد المعتمدة.',
    body: [
      'يحق للعميل إلغاء الطلب قبل بدء مقدم الخدمة بتنفيذه، مع تطبيق سياسة الاسترداد المعتمدة في التطبيق.',
      'في حال الإلغاء بعد بدء التنفيذ، يُحدَّد المبلغ المسترجَع بحسب نسبة العمل المُنجَز فعليًا.',
      'يحتفظ التطبيق بحق التدخل والفصل في أي نزاع متعلق بالإلغاء أو الاسترداد بين الطرفين.'
    ]
  },
  {
    id: 'reviews',
    icon: FiStar,
    title: 'التقييمات والمراجعات',
    tldr: 'قيّم بصدق — التقييمات المسيئة أو الكاذبة تُحذف.',
    body: [
      'التقييمات وسيلة أساسية لبناء الثقة بين المستخدمين، ونشجّع على تقديم تقييمات صادقة وموضوعية.',
      'يحتفظ التطبيق بحق حذف أي تقييم يحتوي على إساءة، ألفاظ غير لائقة، أو معلومات مضلّلة، دون إشعار مسبق.',
      'لا يجوز مقايضة التقييمات الإيجابية بخصومات أو مبالغ مالية.'
    ]
  },
  {
    id: 'content',
    icon: FiShield,
    title: 'المحتوى والملكية الفكرية',
    tldr: 'كل ما تنشره يجب أن يكون لائقًا وملكًا لك.',
    body: [
      'يُمنع نشر أي محتوى مسيء، غير لائق، أو ينتهك حقوق الملكية الفكرية لأطراف أخرى عبر الملف الشخصي أو المحادثات أو المتجر الرقمي.',
      'جميع العلامات التجارية والشعارات والتصاميم الخاصة بالتطبيق مملوكة لمالكيه، ولا يجوز استخدامها دون إذن كتابي.',
      'المحتوى الذي تنشره (صور، وصف الخدمة) يبقى ملكًا لك، لكنك تمنح التطبيق ترخيصًا لعرضه ضمن المنصة فقط.'
    ]
  },
  {
    id: 'privacy',
    icon: FiLock,
    title: 'الخصوصية وحماية البيانات',
    tldr: 'بياناتك محمية ولا تُستخدم إلا لتشغيل الخدمة.',
    body: [
      'نحترم خصوصيتك ونتعامل مع بياناتك الشخصية بسرية تامة، ولا تتم مشاركتها مع أي طرف ثالث إلا بالقدر اللازم لإتمام الخدمة (مثل ربط العميل بمقدم الخدمة).',
      'تُستخدم بيانات الدفع فقط لإتمام المعاملات المالية عبر مزودي دفع معتمدين، ولا يتم تخزين بيانات البطاقة داخل التطبيق.',
      'يمكنك طلب حذف حسابك وبياناتك في أي وقت من خلال التواصل مع فريق الدعم.'
    ]
  },
  {
    id: 'liability',
    icon: FiAlertCircle,
    title: 'حدود المسؤولية',
    tldr: 'التطبيق منصة وسيطة، والمسؤولية عن الخدمة تقع على مقدمها.',
    body: [
      'يعمل التطبيق كوسيط يربط بين العملاء ومقدمي الخدمات، ولا يتحمّل مسؤولية مباشرة عن جودة الخدمة المقدَّمة أو أي ضرر ناتج عنها.',
      'لا يضمن التطبيق التوفر المستمر لجميع الميزات دون انقطاع، وقد تحدث أعطال تقنية مؤقتة يعمل الفريق على حلها في أقرب وقت.'
    ]
  },
  {
    id: 'suspension',
    icon: FiShield,
    title: 'تعليق الحساب وإنهاؤه',
    tldr: 'مخالفة الشروط قد تؤدي لتعليق أو إنهاء الحساب.',
    body: [
      'يحق للتطبيق تعليق أو إنهاء أي حساب يخالف هذه الشروط، مؤقتًا أو بشكل دائم، وفق تقديره الخاص.',
      'يمكنك أيضًا طلب إغلاق حسابك في أي وقت، مع تسوية أي مستحقات مالية معلّقة أولاً.'
    ]
  },
  {
    id: 'changes',
    icon: FiBookOpen,
    title: 'التعديلات على الشروط',
    tldr: 'قد نحدّث هذه الشروط، وسنُعلمك بالتغييرات المهمة.',
    body: [
      'نحتفظ بالحق في تعديل هذه الشروط والأحكام من وقت لآخر لمواكبة تطوير الخدمة أو المتطلبات القانونية.',
      'سيتم إعلامك بأي تغييرات جوهرية عبر إشعار داخل التطبيق، واستمرارك في الاستخدام بعد التعديل يُعد موافقة عليه.'
    ]
  }
];

const RulesAndTermsScreen = () => {
  const [activeId, setActiveId] = useState(SECTIONS[0].id);
  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;

  const scrollToSection = (id) => {
    setActiveId(id);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div dir="rtl" className="min-h-screen bg-[#F6F6F4]" style={{ fontFamily: "'Tajawal', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@700;800&family=Tajawal:wght@400;500;700&display=swap');
        .font-display { font-family: 'Cairo', sans-serif; }
        html { scroll-behavior: smooth; }
        .toc-scroll::-webkit-scrollbar { width: 4px; }
        .toc-scroll::-webkit-scrollbar-thumb { background: #d9d7d0; border-radius: 4px; }
      `}</style>

      <div className="bg-khidma-black text-white">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-14">
          <div className="flex items-center gap-3 mb-3">
            <div className="bg-white/10 rounded-full p-2.5">
              <FiBookOpen className="text-white text-xl" />
            </div>
            <span className="text-white/60 text-sm font-medium">تطبيق خدمة</span>
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold mb-2">القواعد والشروط</h1>
          <p className="text-white/70 max-w-xl text-sm md:text-base leading-relaxed">
            هذه الشروط توضّح حقوقك والتزاماتك عند استخدام تطبيق خدمة، سواء كنت تطلب خدمة أو تقدّمها. اقرأها بعناية.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-1.5 text-xs text-white/70">
            آخر تحديث: {formattedDate}
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 py-8 md:py-12 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-8">

        <aside className="hidden lg:block">
          <div className="sticky top-8 toc-scroll max-h-[80vh] overflow-y-auto pl-1">
            <p className="font-display text-xs font-bold text-gray-400 mb-3 tracking-wide">فهرس المحتويات</p>
            <nav className="flex flex-col gap-1">
              {SECTIONS.map((s, i) => (
                <button
                  key={s.id}
                  onClick={() => scrollToSection(s.id)}
                  className={`text-right text-sm py-2 px-3 rounded-lg transition-colors flex items-center gap-2 ${
                    activeId === s.id
                      ? 'bg-khidma-black text-white font-medium'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <span className="text-xs opacity-60 font-display">{String(i + 1).padStart(2, '0')}</span>
                  {s.title}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        <div className="lg:hidden -mx-4 px-4 overflow-x-auto">
          <div className="flex gap-2 pb-1 w-max">
            {SECTIONS.map((s, i) => (
              <button
                key={s.id}
                onClick={() => scrollToSection(s.id)}
                className={`shrink-0 text-xs py-2 px-3 rounded-full border transition-colors ${
                  activeId === s.id
                    ? 'bg-khidma-black text-white border-khidma-black'
                    : 'border-gray-300 text-gray-600'
                }`}
              >
                {i + 1}. {s.title}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-10">
          {SECTIONS.map((s, i) => {
            const Icon = s.icon;
            return (
              <section id={s.id} key={s.id} className="scroll-mt-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-white border border-gray-200 rounded-lg p-2 shadow-sm">
                    <Icon className="text-khidma-black text-lg" />
                  </div>
                  <h2 className="font-display text-lg md:text-xl font-bold text-gray-900">
                    <span className="text-gray-400 ml-1">{String(i + 1).padStart(2, '0')}</span> {s.title}
                  </h2>
                </div>

                <div className="border-r-4 border-amber-500 bg-amber-50/60 rounded-lg py-2.5 px-4 mb-4 mr-1">
                  <p className="text-xs md:text-sm text-amber-900 font-medium">باختصار: {s.tldr}</p>
                </div>

                <div className="bg-white border border-gray-200 rounded-xl p-5 md:p-6 shadow-sm space-y-3">
                  {s.body.map((p, idx) => (
                    <p key={idx} className="text-sm md:text-base text-gray-700 leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            );
          })}

          <div className="bg-khidma-black text-white rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div>
              <h3 className="font-display text-lg font-bold mb-1">عندك سؤال حول الشروط؟</h3>
              <p className="text-white/70 text-sm">فريق الدعم جاهز للإجابة على استفساراتك في أي وقت.</p>
            </div>
            <a
              href="/contact-us"
              className="shrink-0 bg-white text-khidma-black rounded-lg px-5 py-2.5 text-sm font-bold flex items-center gap-2 hover:bg-gray-100 transition-colors"
            >
              تواصل معنا
              <FiChevronLeft />
            </a>
          </div>

          <div className="mt-4 bg-white border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 shadow-sm">
            <div>
              <h3 className="font-display text-lg font-bold mb-1 text-gray-900">سياسة الخصوصية وحماية البيانات</h3>
              <p className="text-gray-500 text-sm">اقرأ بالتفصيل كيف نحمي بياناتك وحقوقك وفق معايير Google Play.</p>
            </div>
            <a
              href="/privacy-policy"
              className="shrink-0 bg-emerald-600 text-white rounded-lg px-5 py-2.5 text-sm font-bold hover:bg-emerald-700 transition-colors"
            >
              سياسة الخصوصية
            </a>
          </div>

          <div className="mt-4 bg-white border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 shadow-sm">
            <div>
              <h3 className="font-display text-lg font-bold mb-1 text-gray-900">تريد حذف حسابك؟</h3>
              <p className="text-gray-500 text-sm">يمكنك طلب حذف حسابك وبياناتك في أي وقت.</p>
            </div>
            <a
              href="/delete-account"
              className="shrink-0 bg-red-600 text-white rounded-lg px-5 py-2.5 text-sm font-bold hover:bg-red-700 transition-colors"
            >
              حذف الحساب
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesAndTermsScreen;